<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="timeout"
  >
    {{ message }}
    <v-btn
      color="pink"
      text
      @click="snackbar = false"
    >{{ $t('login.close') }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    snackbar: false,
    message: 'message',
    timeout: 5000
  }),
  mounted() {
    this.$root.$on('showSnackbar', this.showSnackbar);
  },
  methods: {
    showSnackbar(message, timeout = 5000) {
      this.message = message;
      this.snackbar = true;
      this.timeout = timeout;
    }
  }
};
</script>
